import { Icon, Text, Tag } from "@ttc3k/trekker";
import { Box, Flex } from "styled-system/jsx";
import { Page } from "iconoir-react";
import { formatPrice } from "shared/utils";

type InvoiceCardProps = {
  invoiceNumber: string;
  title: string;
  amountCents: number;
  dueDateStr?: string;
  recipientName?: string;
  isOverdue?: boolean;
  dueLabel: string;
  overdueLabel: string;
  onClick?: () => void;
};

export const InvoiceCard = ({
  invoiceNumber,
  title,
  amountCents,
  dueDateStr,
  recipientName,
  isOverdue = false,
  dueLabel,
  overdueLabel,
  onClick,
}: InvoiceCardProps) => {
  return (
    <Box
      bg="white"
      border="1px solid"
      borderColor="border.light"
      borderRadius="200"
      p="300"
      cursor={onClick ? "pointer" : undefined}
      _hover={onClick ? { borderColor: "border.mid" } : undefined}
      onClick={onClick}
    >
      <Flex justifyContent="space-between" alignItems="center">
        <Flex alignItems="flex-start" gap="150">
          <Box mt="2px" flexShrink={0}>
            <Icon
              Element={Page}
              color={isOverdue ? "icon.error.mid" : "icon.warning.mid"}
              size="sm"
            />
          </Box>
          <Flex flexDir="column">
            <Text visual="bodySemiBold" color="text.dark">
              {title}
            </Text>
            <Text visual="smallRegular" color="text.light">
              #{invoiceNumber}
            </Text>
            {recipientName && (
              <Text visual="smallRegular" color="text.mid">
                {recipientName}
              </Text>
            )}
            <Text visual="smallRegular" color="text.mid">
              ${formatPrice(amountCents)}
            </Text>
            {dueDateStr && (
              <Text visual="smallRegular" color="text.light">
                {dueDateStr}
              </Text>
            )}
          </Flex>
        </Flex>
        <Tag
          visual={isOverdue ? "destructive" : "warning"}
          mode="light"
        >
          {isOverdue ? overdueLabel : dueLabel}
        </Tag>
      </Flex>
    </Box>
  );
};
